'use client';

import { c as _c } from "react/compiler-runtime";
import { ScheduleEntriesProvider } from '@/context/schedule-entries-context';
import { StarProvider } from '@/context/star-context';
import type React from 'react';
import type { ReactNode } from 'react';
interface ClientProvidersProperties {
  children: ReactNode;
}

// Both providers render on the server. Loading them with `ssr: false` made this boundary, which
// holds the whole application, bail out to client-side rendering and ship an empty `<body>`.
export const ClientProviders: React.FC<ClientProvidersProperties> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <StarProvider><ScheduleEntriesProvider>{children}</ScheduleEntriesProvider></StarProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};